import React, { useCallback } from "react";
import HeroButton from "/app/src/components/HeroUi/Button";
import { useTranslation } from "react-i18next";

/**
 * RefreshSetting component that toggles the new setting state and triggers a refresh.
 * @param {Object} props - The component props.
 * @param {() => void} props.refresh - Function to refresh.
 * @param {boolean} props.newSetting - Current setting state.
 * @param {(newSetting: boolean) => void} props.setNewSetting - Function to update the setting.
 * @returns {JSX.Element} The rendered HeroButton component.
 */
export default function RefreshSetting({
  refresh,
  newSetting,
  setNewSetting,
}: {
  refresh: () => void;
  newSetting: boolean;
  setNewSetting: (newSetting: boolean) => void;
}) {
  const { t } = useTranslation();

  const newSettingSetter = useCallback(() => {
    refresh();
    setNewSetting(!newSetting);
  }, [refresh, newSetting, setNewSetting]);

  return (
    <HeroButton color="primary" onClick={newSettingSetter} size="sm">
      {t("translation:refresh_list")}
    </HeroButton>
  );
}
